import { z } from 'zod';

import { OptionalPhoneNumber } from '../../../Phone';
import { OptionalEmailString } from '../../email';
import { AddressLine, Checkbox, DateString, NonNegativeMonetaryValue } from '../../fields';

export const InsuranceFields = z.object({
  hazardInsuranceIsEscrowed: Checkbox.optional(),
  hazardInsuranceAmount: NonNegativeMonetaryValue.optional(),
  hazardInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  hazardInsuranceAgentName: z.string().optional(),
  hazardInsuranceAgentEmail: OptionalEmailString,
  hazardInsuranceAgentPhone: OptionalPhoneNumber,
  hazardInsuranceCompanyName: z.string().optional(),
  hazardInsuranceCompanyAddressLine1: AddressLine.optional(),
  hazardInsuranceCompanyAddressLine2: AddressLine.optional(),
  hazardInsuranceCompanyAddressCity: z.string().optional(),
  hazardInsuranceCompanyAddressState: z.string().optional(),
  hazardInsuranceCompanyAddressZip: z.string().optional(),
  hazardInsurancePolicyNumber: z.string().optional(),
  hazardInsurancePolicyStart: DateString.optional(),
  hazardInsurancePolicyEnd: DateString.optional(),
  hazardInsuranceForcedPlacedFlag: Checkbox.optional(),

  homeownersInsuranceIsEscrowed: Checkbox.optional(),
  homeownersInsuranceAmount: NonNegativeMonetaryValue.optional(),
  homeownersInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  homeownersInsuranceAgentName: z.string().optional(),
  homeownersInsuranceAgentEmail: OptionalEmailString,
  homeownersInsuranceAgentPhone: OptionalPhoneNumber,
  homeownersInsuranceCompanyName: z.string().optional(),
  homeownersInsuranceCompanyAddressLine1: AddressLine.optional(),
  homeownersInsuranceCompanyAddressLine2: AddressLine.optional(),
  homeownersInsuranceCompanyAddressCity: z.string().optional(),
  homeownersInsuranceCompanyAddressState: z.string().optional(),
  homeownersInsuranceCompanyAddressZip: z.string().optional(),
  homeownersInsurancePolicyNumber: z.string().optional(),
  homeownersInsurancePolicyStart: DateString.optional(),
  homeownersInsurancePolicyEnd: DateString.optional(),
  homeownersInsuranceForcedPlacedFlag: Checkbox.optional(),

  floodInsuranceIsEscrowed: Checkbox.optional(),
  floodInsuranceAmount: NonNegativeMonetaryValue.optional(),
  floodInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  floodInsuranceAgentName: z.string().optional(),
  floodInsuranceAgentEmail: OptionalEmailString,
  floodInsuranceAgentPhone: OptionalPhoneNumber,
  floodInsuranceCompanyName: z.string().optional(),
  floodInsuranceCompanyAddressLine1: AddressLine.optional(),
  floodInsuranceCompanyAddressLine2: AddressLine.optional(),
  floodInsuranceCompanyAddressCity: z.string().optional(),
  floodInsuranceCompanyAddressState: z.string().optional(),
  floodInsuranceCompanyAddressZip: z.string().optional(),
  floodInsurancePolicyNumber: z.string().optional(),
  floodInsurancePolicyStart: DateString.optional(),
  floodInsurancePolicyEnd: DateString.optional(),
  floodInsuranceForcedPlacedFlag: Checkbox.optional(),

  windstormInsuranceIsEscrowed: Checkbox.optional(),
  windstormInsuranceAmount: NonNegativeMonetaryValue.optional(),
  windstormInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  windstormInsuranceAgentName: z.string().optional(),
  windstormInsuranceAgentEmail: OptionalEmailString,
  windstormInsuranceAgentPhone: OptionalPhoneNumber,
  windstormInsuranceCompanyName: z.string().optional(),
  windstormInsuranceCompanyAddressLine1: AddressLine.optional(),
  windstormInsuranceCompanyAddressLine2: AddressLine.optional(),
  windstormInsuranceCompanyAddressCity: z.string().optional(),
  windstormInsuranceCompanyAddressState: z.string().optional(),
  windstormInsuranceCompanyAddressZip: z.string().optional(),
  windstormInsurancePolicyNumber: z.string().optional(),
  windstormInsurancePolicyStart: DateString.optional(),
  windstormInsurancePolicyEnd: DateString.optional(),
  windstormInsuranceForcedPlacedFlag: Checkbox.optional(),

  hurricaneInsuranceIsEscrowed: Checkbox.optional(),
  hurricaneInsuranceAmount: NonNegativeMonetaryValue.optional(),
  hurricaneInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  hurricaneInsuranceAgentName: z.string().optional(),
  hurricaneInsuranceAgentEmail: OptionalEmailString,
  hurricaneInsuranceAgentPhone: OptionalPhoneNumber,
  hurricaneInsuranceCompanyName: z.string().optional(),
  hurricaneInsuranceCompanyAddressLine1: AddressLine.optional(),
  hurricaneInsuranceCompanyAddressLine2: AddressLine.optional(),
  hurricaneInsuranceCompanyAddressCity: z.string().optional(),
  hurricaneInsuranceCompanyAddressState: z.string().optional(),
  hurricaneInsuranceCompanyAddressZip: z.string().optional(),
  hurricaneInsurancePolicyNumber: z.string().optional(),
  hurricaneInsurancePolicyStart: DateString.optional(),
  hurricaneInsurancePolicyEnd: DateString.optional(),
  hurricaneInsuranceForcedPlacedFlag: Checkbox.optional(),

  fireInsuranceIsEscrowed: Checkbox.optional(),
  fireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  fireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  fireInsuranceAgentName: z.string().optional(),
  fireInsuranceAgentEmail: OptionalEmailString,
  fireInsuranceAgentPhone: OptionalPhoneNumber,
  fireInsuranceCompanyName: z.string().optional(),
  fireInsuranceCompanyAddressLine1: AddressLine.optional(),
  fireInsuranceCompanyAddressLine2: AddressLine.optional(),
  fireInsuranceCompanyAddressCity: z.string().optional(),
  fireInsuranceCompanyAddressState: z.string().optional(),
  fireInsuranceCompanyAddressZip: z.string().optional(),
  fireInsurancePolicyNumber: z.string().optional(),
  fireInsurancePolicyStart: DateString.optional(),
  fireInsurancePolicyEnd: DateString.optional(),
  fireInsuranceForcedPlacedFlag: Checkbox.optional(),

  liabilityInsuranceIsEscrowed: Checkbox.optional(),
  liabilityInsuranceAmount: NonNegativeMonetaryValue.optional(),
  liabilityInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  liabilityInsuranceAgentName: z.string().optional(),
  liabilityInsuranceAgentEmail: OptionalEmailString,
  liabilityInsuranceAgentPhone: OptionalPhoneNumber,
  liabilityInsuranceCompanyName: z.string().optional(),
  liabilityInsuranceCompanyAddressLine1: AddressLine.optional(),
  liabilityInsuranceCompanyAddressLine2: AddressLine.optional(),
  liabilityInsuranceCompanyAddressCity: z.string().optional(),
  liabilityInsuranceCompanyAddressState: z.string().optional(),
  liabilityInsuranceCompanyAddressZip: z.string().optional(),
  liabilityInsurancePolicyNumber: z.string().optional(),
  liabilityInsurancePolicyStart: DateString.optional(),
  liabilityInsurancePolicyEnd: DateString.optional(),
  liabilityInsuranceForcedPlacedFlag: Checkbox.optional(),

  rentalInsuranceIsEscrowed: Checkbox.optional(),
  rentalInsuranceAmount: NonNegativeMonetaryValue.optional(),
  rentalInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  rentalInsuranceAgentName: z.string().optional(),
  rentalInsuranceAgentEmail: OptionalEmailString,
  rentalInsuranceAgentPhone: OptionalPhoneNumber,
  rentalInsuranceCompanyName: z.string().optional(),
  rentalInsuranceCompanyAddressLine1: AddressLine.optional(),
  rentalInsuranceCompanyAddressLine2: AddressLine.optional(),
  rentalInsuranceCompanyAddressCity: z.string().optional(),
  rentalInsuranceCompanyAddressState: z.string().optional(),
  rentalInsuranceCompanyAddressZip: z.string().optional(),
  rentalInsurancePolicyNumber: z.string().optional(),
  rentalInsurancePolicyStart: DateString.optional(),
  rentalInsurancePolicyEnd: DateString.optional(),
  rentalInsuranceForcedPlacedFlag: Checkbox.optional(),

  condoInsuranceIsEscrowed: Checkbox.optional(),
  condoInsuranceAmount: NonNegativeMonetaryValue.optional(),
  condoInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  condoInsuranceAgentName: z.string().optional(),
  condoInsuranceAgentEmail: OptionalEmailString,
  condoInsuranceAgentPhone: OptionalPhoneNumber,
  condoInsuranceCompanyName: z.string().optional(),
  condoInsuranceCompanyAddressLine1: AddressLine.optional(),
  condoInsuranceCompanyAddressLine2: AddressLine.optional(),
  condoInsuranceCompanyAddressCity: z.string().optional(),
  condoInsuranceCompanyAddressState: z.string().optional(),
  condoInsuranceCompanyAddressZip: z.string().optional(),
  condoInsurancePolicyNumber: z.string().optional(),
  condoInsurancePolicyStart: DateString.optional(),
  condoInsurancePolicyEnd: DateString.optional(),
  condoInsuranceForcedPlacedFlag: Checkbox.optional(),

  earthquakeInsuranceIsEscrowed: Checkbox.optional(),
  earthquakeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  earthquakeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  earthquakeInsuranceAgentName: z.string().optional(),
  earthquakeInsuranceAgentEmail: OptionalEmailString,
  earthquakeInsuranceAgentPhone: OptionalPhoneNumber,
  earthquakeInsuranceCompanyName: z.string().optional(),
  earthquakeInsuranceCompanyAddressLine1: AddressLine.optional(),
  earthquakeInsuranceCompanyAddressLine2: AddressLine.optional(),
  earthquakeInsuranceCompanyAddressCity: z.string().optional(),
  earthquakeInsuranceCompanyAddressState: z.string().optional(),
  earthquakeInsuranceCompanyAddressZip: z.string().optional(),
  earthquakeInsurancePolicyNumber: z.string().optional(),
  earthquakeInsurancePolicyStart: DateString.optional(),
  earthquakeInsurancePolicyEnd: DateString.optional(),
  earthquakeInsuranceForcedPlacedFlag: Checkbox.optional(),

  umbrellaInsuranceIsEscrowed: Checkbox.optional(),
  umbrellaInsuranceAmount: NonNegativeMonetaryValue.optional(),
  umbrellaInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  umbrellaInsuranceAgentName: z.string().optional(),
  umbrellaInsuranceAgentEmail: OptionalEmailString,
  umbrellaInsuranceAgentPhone: OptionalPhoneNumber,
  umbrellaInsuranceCompanyName: z.string().optional(),
  umbrellaInsuranceCompanyAddressLine1: AddressLine.optional(),
  umbrellaInsuranceCompanyAddressLine2: AddressLine.optional(),
  umbrellaInsuranceCompanyAddressCity: z.string().optional(),
  umbrellaInsuranceCompanyAddressState: z.string().optional(),
  umbrellaInsuranceCompanyAddressZip: z.string().optional(),
  umbrellaInsurancePolicyNumber: z.string().optional(),
  umbrellaInsurancePolicyStart: DateString.optional(),
  umbrellaInsurancePolicyEnd: DateString.optional(),
  umbrellaInsuranceForcedPlacedFlag: Checkbox.optional(),

  sinkholeInsuranceIsEscrowed: Checkbox.optional(),
  sinkholeInsuranceAmount: NonNegativeMonetaryValue.optional(),
  sinkholeInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  sinkholeInsuranceAgentName: z.string().optional(),
  sinkholeInsuranceAgentEmail: OptionalEmailString,
  sinkholeInsuranceAgentPhone: OptionalPhoneNumber,
  sinkholeInsuranceCompanyName: z.string().optional(),
  sinkholeInsuranceCompanyAddressLine1: AddressLine.optional(),
  sinkholeInsuranceCompanyAddressLine2: AddressLine.optional(),
  sinkholeInsuranceCompanyAddressCity: z.string().optional(),
  sinkholeInsuranceCompanyAddressState: z.string().optional(),
  sinkholeInsuranceCompanyAddressZip: z.string().optional(),
  sinkholeInsurancePolicyNumber: z.string().optional(),
  sinkholeInsurancePolicyStart: DateString.optional(),
  sinkholeInsurancePolicyEnd: DateString.optional(),
  sinkholeInsuranceForcedPlacedFlag: Checkbox.optional(),

  wildfireInsuranceIsEscrowed: Checkbox.optional(),
  wildfireInsuranceAmount: NonNegativeMonetaryValue.optional(),
  wildfireInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  wildfireInsuranceAgentName: z.string().optional(),
  wildfireInsuranceAgentEmail: OptionalEmailString,
  wildfireInsuranceAgentPhone: OptionalPhoneNumber,
  wildfireInsuranceCompanyName: z.string().optional(),
  wildfireInsuranceCompanyAddressLine1: AddressLine.optional(),
  wildfireInsuranceCompanyAddressLine2: AddressLine.optional(),
  wildfireInsuranceCompanyAddressCity: z.string().optional(),
  wildfireInsuranceCompanyAddressState: z.string().optional(),
  wildfireInsuranceCompanyAddressZip: z.string().optional(),
  wildfireInsurancePolicyNumber: z.string().optional(),
  wildfireInsurancePolicyStart: DateString.optional(),
  wildfireInsurancePolicyEnd: DateString.optional(),
  wildfireInsuranceForcedPlacedFlag: Checkbox.optional(),

  sewerInsuranceIsEscrowed: Checkbox.optional(),
  sewerInsuranceAmount: NonNegativeMonetaryValue.optional(),
  sewerInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  sewerInsuranceAgentName: z.string().optional(),
  sewerInsuranceAgentEmail: OptionalEmailString,
  sewerInsuranceAgentPhone: OptionalPhoneNumber,
  sewerInsuranceCompanyName: z.string().optional(),
  sewerInsuranceCompanyAddressLine1: AddressLine.optional(),
  sewerInsuranceCompanyAddressLine2: AddressLine.optional(),
  sewerInsuranceCompanyAddressCity: z.string().optional(),
  sewerInsuranceCompanyAddressState: z.string().optional(),
  sewerInsuranceCompanyAddressZip: z.string().optional(),
  sewerInsurancePolicyNumber: z.string().optional(),
  sewerInsurancePolicyStart: DateString.optional(),
  sewerInsurancePolicyEnd: DateString.optional(),
  sewerInsuranceForcedPlacedFlag: Checkbox.optional(),

  equipmentInsuranceIsEscrowed: Checkbox.optional(),
  equipmentInsuranceAmount: NonNegativeMonetaryValue.optional(),
  equipmentInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  equipmentInsuranceAgentName: z.string().optional(),
  equipmentInsuranceAgentEmail: OptionalEmailString,
  equipmentInsuranceAgentPhone: OptionalPhoneNumber,
  equipmentInsuranceCompanyName: z.string().optional(),
  equipmentInsuranceCompanyAddressLine1: AddressLine.optional(),
  equipmentInsuranceCompanyAddressLine2: AddressLine.optional(),
  equipmentInsuranceCompanyAddressCity: z.string().optional(),
  equipmentInsuranceCompanyAddressState: z.string().optional(),
  equipmentInsuranceCompanyAddressZip: z.string().optional(),
  equipmentInsurancePolicyNumber: z.string().optional(),
  equipmentInsurancePolicyStart: DateString.optional(),
  equipmentInsurancePolicyEnd: DateString.optional(),
  equipmentInsuranceForcedPlacedFlag: Checkbox.optional(),

  titleInsuranceIsEscrowed: Checkbox.optional(),
  titleInsuranceAmount: NonNegativeMonetaryValue.optional(),
  titleInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  titleInsuranceAgentName: z.string().optional(),
  titleInsuranceAgentEmail: OptionalEmailString,
  titleInsuranceAgentPhone: OptionalPhoneNumber,
  titleInsuranceCompanyName: z.string().optional(),
  titleInsuranceCompanyAddressLine1: AddressLine.optional(),
  titleInsuranceCompanyAddressLine2: AddressLine.optional(),
  titleInsuranceCompanyAddressCity: z.string().optional(),
  titleInsuranceCompanyAddressState: z.string().optional(),
  titleInsuranceCompanyAddressZip: z.string().optional(),
  titleInsurancePolicyNumber: z.string().optional(),
  titleInsurancePolicyStart: DateString.optional(),
  titleInsurancePolicyEnd: DateString.optional(),
  titleInsuranceForcedPlacedFlag: Checkbox.optional(),

  otherInsuranceIsEscrowed: Checkbox.optional(),
  otherInsuranceAmount: NonNegativeMonetaryValue.optional(),
  otherInsuranceCoverageAmount: NonNegativeMonetaryValue.optional(),
  otherInsuranceAgentName: z.string().optional(),
  otherInsuranceAgentEmail: OptionalEmailString,
  otherInsuranceAgentPhone: OptionalPhoneNumber,
  otherInsuranceCompanyName: z.string().optional(),
  otherInsuranceCompanyAddressLine1: AddressLine.optional(),
  otherInsuranceCompanyAddressLine2: AddressLine.optional(),
  otherInsuranceCompanyAddressCity: z.string().optional(),
  otherInsuranceCompanyAddressState: z.string().optional(),
  otherInsuranceCompanyAddressZip: z.string().optional(),
  otherInsurancePolicyNumber: z.string().optional(),
  otherInsurancePolicyStart: DateString.optional(),
  otherInsurancePolicyEnd: DateString.optional(),
  otherInsuranceForcedPlacedFlag: Checkbox.optional(),
});

export type InsuranceFields = z.infer<typeof InsuranceFields>;
